export default __webpack_public_path__ + "static/media/simple-linkedin.65efd6fe.svg";